import { useLiveAPIContext } from "../../contexts/LiveAPIContext";
// import { Canvas } from "@react-three/fiber";
// import Avatar from "./Avatar";
import FluidAvatar from "./FluidAvatar";
import "./avatar-wrapper.scss"

const AvatarWrapper = () => {
  const { volume } = useLiveAPIContext();

  return (
    // <div style={{ width: "13vw", height: "13vw", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
    <div className="avatar-wrapper" >
    <FluidAvatar volume={volume}/>
      {/* <Canvas
      style={{ width: "30%", height: "30%", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}
      camera={{
        position: [0, 0, 0.5],
        fov: 70,
      }}
    >
      <ambientLight intensity={2} />
      <pointLight position={[10, 10, 10]} intensity={5} />
      <Avatar
        url="https://models.readyplayer.me/678897e597c45963840a18a6.glb?morphTargets=ARKit&textureAtlas=1024"
        volume={volume}
      />
    </Canvas> */}
    </div>
  );
};

export default AvatarWrapper;
